import { v4 as uuidv4 } from 'uuid'

export const feeModelTestData = () => {
  return {
    title: 'Fee Model',
    item: 'Hybrid',
    key: uuidv4()
  }
}
